/*
----------------------------
Module - table
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.responsiveTables = function() {

        function setupDragScroll() {

            var table_wrappers = document.querySelector('.table-wrapper');
            var isDown = false;
            var startX;
            var scrollLeft;

            table_wrappers.addEventListener('mousedown', (e) => {
                isDown = true;
                table_wrappers.classList.add(table_wrapper_active_class);
                startX = e.pageX - table_wrappers.offsetLeft;
                scrollLeft = table_wrappers.scrollLeft;
            });

            table_wrappers.addEventListener('mouseleave', () => {
                isDown = false;
                table_wrappers.classList.remove(table_wrapper_active_class);
            });

            table_wrappers.addEventListener('mouseup', () => {
                isDown = false;
                table_wrappers.classList.remove(table_wrapper_active_class);
            });

            table_wrappers.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                var x = e.pageX - table_wrappers.offsetLeft;
                var walk = (x - startX);
                table_wrappers.scrollLeft = scrollLeft - walk;
            });

            table_wrappers.addEventListener('scroll', tableWrapperScrolled);
            table_wrappers.addEventListener('scroll', handleWhiteBox);
        }

        function handleWhiteBox(e) {
            var $this_table = $(e.target);

            if ($this_table.scrollLeft() == 0) {
                $('.white-box-left').remove();
            } else if($('.white-box-left').length == 0) {
                $('<div class="white-box-left"></div>').insertBefore('.table-wrapper');
                $('.white-box-left').height($(".table--responsive").height());                
            }

            var table_wrappers = document.querySelector('.table-wrapper');
            var maxScrollLeft =  table_wrappers.scrollWidth - table_wrappers.clientWidth;

            if ($this_table.scrollLeft() == maxScrollLeft) {
                $('.white-box-right').remove();
            } else if($('.white-box-right').length == 0) {
                $('<div class="white-box-right"></div>').insertBefore('.table-wrapper');
                $('.white-box-right').height($(".table--responsive").height());                
            }

        }

        function tableWrapperScrolled(e) {
            
            var $this_table = $(e.target);
            
            // Remove overflow chevron class
            $this_table.find("." + overflow_chevron_class).removeClass(overflow_chevron_class);

            // We want this scroll event to run only once
            e.target.removeEventListener("scroll", tableWrapperScrolled);

        }

        function setupResponsiveTables() {

            $responsive_tables.each(function() {

                var $this_table = $(this);

                $this_table.wrap('<div class="table-wrapper"><div class="table-wrapper__inner"></div></div>');

                var $this_table_rows = $this_table.find("tbody tr");

                if ($this_table_rows.length > 2) {

                    $this_table_rows.filter(":nth-child(2)").addClass(overflow_chevron_class);

                } else {

                    $this_table_rows.filter(":first").addClass(overflow_chevron_class);

                }

            });
                    
            setupDragScroll();
            

        }

        function init() {

            $responsive_tables = $(".table--responsive");
            
            if ($responsive_tables.length) {

                setupResponsiveTables();

            }

        }

        var $responsive_tables;
        var table_wrapper_active_class = "table-wrapper--active";
        var overflow_chevron_class = "table-row--overflow-chevron";
        
        return {
            init: init
        };

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        fmg.responsiveTables.init();
    });

    window.addEventListener("load", function() {
        $('<div class="white-box-right"></div>').insertBefore('.table-wrapper');
        $('.white-box-right').height($(".table--responsive").height());
    });


}());
